import { resolveSpecieLevelCodes } from "@carnet/ui/utils/specieLevel";

export function useSpecieLevelFilter() {
  const { data: profile } = useProfileData();
  const isNaturalist = computed(() => profile.value?.isNaturalist ?? false);
  const { multi } = useUrlFilterValues();
  const selectedLevelCodes = multi("specieLevels");
  const requestLevelCodes = computed(() => resolveSpecieLevelCodes(isNaturalist.value, selectedLevelCodes.value));
  return { isNaturalist, selectedLevelCodes, requestLevelCodes };
}
